export default {
  state: {
    appInfo: '',
    refreshOrders: false, // 是否刷新订单列表
    canIUseCanGoBack: false // 能否使用appWebviewBack这个桥
  },
  mutations: {
    setAppInfo (state, data) {
      state.appInfo = data
    },
    setRrefreshOrders (state, value) {
      state.refreshOrders = value
    },
    setCanIUseCanGoBack (state, value) {
      state.canIUseCanGoBack = value
    }
  },
  getters: {
    refreshOrders: state => state.refreshOrders,
    getAppInfo: state => state.appInfo,
    canIUseCanGoBack: state => state.canIUseCanGoBack
  }
}
